module.exports = __webpack_public_path__ + "img/location-point.aedc522d.svg";